import React from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import Popup from '../../../../components/Popup';
import ROUTE from '../../../../constants/route';
import UxHelpers from '../../../../helpers/ux-helpers';
import Dialog from '../../index';

const UpgradeCandidateAccount = props => {
  const { show, proceed, dismiss, history } = props;

  const dismissHandler = () => {
    dismiss();
    UxHelpers.overflowLock('unlock');
  };

  const onSuccess = () => {
    history.push(ROUTE.CANDIDATE_UPGRADE_PREMIUM, {
      returnUrl: window.location.pathname,
    });
    proceed();
    UxHelpers.overflowLock('unlock');
  };

  const buttons = (
    <BasicButtonGroup
      groupStyles={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <BasicButton
        controlFunc={onSuccess}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText={'Upgrade'}
      />
      <BasicButton
        controlFunc={dismissHandler}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText={'No Thanks'}
      />
    </BasicButtonGroup>
  );

  const body = (
    <Dialog>
      <p style={{ width: '100%', textAlign: 'center' }}>
        Upgrade to premium to access this feature
      </p>
    </Dialog>
  );

  return (
    show && (
      <Popup
        actions={{
          dismiss,
        }}
        buttonsRender={buttons}
        bodyRender={body}
      />
    )
  );
};

export default createConfirmation(confirmable(UpgradeCandidateAccount));
